"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _headColumn = _interopRequireDefault(require("../columns/head-column"));
var _actions = _interopRequireDefault(require("../../../../elements/other/actions"));
var _chartCommon = require("../common/chart-common");
var _price = _interopRequireDefault(require("@site/pattern-library-core/price"));
var _text = _interopRequireDefault(require("@ux/text"));
/**
 * Local Imports
*/

const StickyRow = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "StickyRow",
  class: "pl-sujdwce",
  vars: {
    "sujdwce-0": [({
      disableSticky
    }) => disableSticky ? 'static' : 'sticky'],
    "sujdwce-1": [({
      skipOffsetForNav
    }) => skipOffsetForNav ? 0 : '3.75rem']
  }
});
const Row = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Row",
  class: "pl-r1nandvh",
  vars: {
    "r1nandvh-0": [({
      col = 2
    }) => `20vw repeat(${col}, 1fr)`]
  }
});
const RowWrapper = /*#__PURE__*/(0, _react2.styled)(Row)({
  name: "RowWrapper",
  class: "pl-r1akcqq3",
  vars: {
    "r1akcqq3-1": [({
      flagText
    }) => flagText ? '0' : `${_intents.default.ux.box.borderRadius} ${_intents.default.ux.box.borderRadius} 0 0`]
  }
});
const TitleContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "TitleContainer",
  class: "pl-tdmu4v4"
});
const ButtonWrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "ButtonWrapper",
  class: "pl-b1nqug4b"
});
const ContentWrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "ContentWrapper",
  class: "pl-cnfuf0j"
});

/**
 * HeadRow Component.
 *
 * @param {Object} props React props
 * @param {Object} props.title Section title name
 * @param {Array} props.items Array of header columns
 * @param {Boolean} props.disableSticky Sticky header condition
 * @param {Boolean} props.skipOffsetForNav Navigation offset condition
 * @returns {React.ReactElement} HeadRow Component
 * @public
 */

function HeadRow({
  title,
  items,
  disableSticky = false,
  skipOffsetForNav = false
}) {
  const hasFlagText = items?.some(item => item?.flagText);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(StickyRow, {
    "data-cy": "sticky-panel",
    disableSticky: disableSticky,
    skipOffsetForNav: skipOffsetForNav
  }, /*#__PURE__*/_react.default.createElement(RowWrapper, {
    role: "row",
    "data-cy": "desktop",
    col: items?.length,
    flagText: hasFlagText
  }, /*#__PURE__*/_react.default.createElement(TitleContainer, {
    role: "cell"
  }, /*#__PURE__*/_react.default.createElement(_text.default.h2, {
    as: "title",
    size: 1,
    text: title,
    "data-cy": "section-title"
  })), items?.slice(0, 4).map((item, idx) => {
    return /*#__PURE__*/_react.default.createElement("div", {
      key: idx,
      "data-cy": "headline-cell",
      role: "cell"
    }, /*#__PURE__*/_react.default.createElement(_headColumn.default, item));
  })), items?.some(item => item?.price != null) && /*#__PURE__*/_react.default.createElement(RowWrapper, {
    role: "row",
    col: items?.length
  }, /*#__PURE__*/_react.default.createElement("div", {
    role: "cell",
    "aria-hidden": true
  }), items?.slice(0, 4).map((item, idx) => {
    return /*#__PURE__*/_react.default.createElement("div", {
      key: idx,
      role: "cell"
    }, item?.price && /*#__PURE__*/_react.default.createElement(_price.default, (0, _extends2.default)({}, item.price, {
      headlineSize: "h5"
    })));
  }))), items?.some(item => item?.ctas?.length > 0) && /*#__PURE__*/_react.default.createElement(Row, {
    role: "row",
    col: items?.length
  }, /*#__PURE__*/_react.default.createElement("div", {
    role: "cell",
    "aria-hidden": true
  }), items?.slice(0, 4).map((item, idx) => {
    return /*#__PURE__*/_react.default.createElement(ButtonWrapper, {
      key: idx,
      role: "cell"
    }, item?.ctas?.length > 0 && /*#__PURE__*/_react.default.createElement(_actions.default, {
      actionsLayout: "button-set",
      ctas: item.ctas
    }));
  })), items?.some(item => item?.description || item?.disclaimer) && /*#__PURE__*/_react.default.createElement(Row, {
    role: "row",
    col: items?.length
  }, /*#__PURE__*/_react.default.createElement("div", {
    role: "cell",
    "aria-hidden": true
  }), items?.slice(0, 4).map((item, idx) => {
    return /*#__PURE__*/_react.default.createElement(ContentWrapper, {
      key: idx,
      role: "cell"
    }, item.disclaimer && /*#__PURE__*/_react.default.createElement(_chartCommon.DisclaimerItem, {
      text: item?.disclaimer
    }), item.description && /*#__PURE__*/_react.default.createElement(_chartCommon.DescriptionItem, {
      text: item?.description
    }));
  })));
}
var _default = exports.default = HeadRow;
HeadRow.propTypes = {
  title: _propTypes.default.string,
  items: _propTypes.default.array,
  disableSticky: _propTypes.default.bool,
  skipOffsetForNav: _propTypes.default.bool
};